import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { FaPhone, FaEnvelope } from 'react-icons/fa';
import './App.css';

import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import NotFound from './pages/NotFound';
import CookieConsent from './components/CookieConsent';
import { trackPageView } from './utils/analytics';

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);
  useEffect(() => {
    if (!hash) {
      // Must use 'instant' to override CSS scroll-behavior: smooth
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }
    // Track page view on every route change (SPA)
    trackPageView(pathname + (hash || ''));
  }, [pathname, hash]);
  return null;
}

function App() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <HelmetProvider>
    <Router>
      <ScrollToTop />
      <div className="App">
        {/* NAV */}
        <nav className="main-nav">
          <div className="nav-inner">
            <div className="nav-logo">
              <Link to="/" onClick={() => setMenuOpen(false)}>
                <img src="/MediaMarsLogoLow.PNG" alt="Media Mars Logo" />
              </Link>
            </div>
            <a href="tel:+441793250401" className="nav-phone">
              <FaPhone className="nav-phone__icon" />
              <span className="nav-phone__text">Call Us: <strong>01793 250401</strong></span>
            </a>
            <div id="primary-navigation" className={`nav-links ${menuOpen ? 'active' : ''}`}>
              <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
              <Link to="/services" onClick={() => setMenuOpen(false)}>Solutions</Link>
              <Link to="/about" onClick={() => setMenuOpen(false)}>About</Link>
              <Link to="/contact" onClick={() => setMenuOpen(false)} className="nav-cta">Contact</Link>
            </div>
            <button
              type="button"
              className={`hamburger ${menuOpen ? 'open' : ''}`}
              onClick={() => setMenuOpen(p => !p)}
              aria-label={menuOpen ? 'Close navigation menu' : 'Open navigation menu'}
              aria-expanded={menuOpen}
              aria-controls="primary-navigation"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </nav>

        {/* PAGES */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>

      {/* FOOTER */}
      <footer className="site-footer">
        <div className="footer-inner">
          <div className="footer-brand">
            <img src="/MediaMarsLogoLow.PNG" alt="Media Mars" className="footer-logo" />
            <p>IT solutions that solve real business problems.</p>
          </div>
          <div className="footer-links">
            <h4>Company</h4>
            <Link to="/">Home</Link>
            <Link to="/services">Solutions</Link>
            <Link to="/about">About</Link>
            <Link to="/contact">Contact</Link>
          </div>
          <div className="footer-links">
            <h4>Legal</h4>
            <Link to="/terms">Terms &amp; Conditions</Link>
            <Link to="/privacy">Privacy Policy</Link>
          </div>
          <div className="footer-links">
            <h4>Contact</h4>
            <a href="mailto:info@media-mars.com">info@media-mars.com</a>
            <a href="tel:+441793250401">01793 250401</a>
            <span>Rombourne Business Centres<br />Kingston House, Lydiard Fields<br />Swindon, Wiltshire SN5 8UB, UK</span>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Media Mars Ltd. All rights reserved.</p>
        </div>
      </footer>

      {/* MOBILE STICKY CTA */}
      <div className="mobile-cta-bar">
        <a href="mailto:info@media-mars.com" className="mobile-cta-btn mobile-cta-email">
          <FaEnvelope /> Email Us
        </a>
        <a href="tel:+441793250401" className="mobile-cta-btn mobile-cta-call">
          <FaPhone /> Call Us
        </a>
      </div>

      <CookieConsent />
    </Router>
    </HelmetProvider>
  );
}

export default App;
